import { DesktopTabView } from './DesktopTabView';
import { MobileSliderView } from './MobileSliderView';
import { ProductDescription, ProductTheme } from './types';
interface ProductSectionContentProps {
  descriptions: readonly ProductDescription[];
  theme: ProductTheme;
}
export const ProductSectionContent = ({
  descriptions,
  theme
}: ProductSectionContentProps) => {
  return <>
      <div className="max-lg:hidden">
        <DesktopTabView descriptions={descriptions} theme={theme} data-sentry-element="DesktopTabView" data-sentry-source-file="ProductSectionContent.tsx" />
      </div>
      <div className="-mx-quiz-md tablet:-mx-quiz-lg lg:hidden">
        <MobileSliderView descriptions={descriptions} theme={theme} data-sentry-element="MobileSliderView" data-sentry-source-file="ProductSectionContent.tsx" />
      </div>
    </>;
};